import styled from "styled-components";
type ImageProps = {
  $img: string;
};

export const ScrollContainer2Section = styled.div`
  display: flex;
`;
export const Span1 = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  margin-right: 5px;
  color: #a7a7a7;
`;
export const RatingItem = styled.div<ImageProps>`
  width: 430px;
  height: 630px;
  margin-bottom: 40px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;
export const Tag = styled.div`
  margin-left: 20px;
  margin-top: 30px;
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  width: 260px;
  padding: 5px 0px;
  border-radius: 20px;
  background-color: #bfdcf5;
`;
export const RatingTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 520px;
`;
export const Part1 = styled.div`
  width: 370px;
  margin-left: 20px;
`;
export const Part2 = styled.div`
  width: 370px;
`;

export const Part1Text1 = styled.div`
  font-family: Cormorant Infant;
  font-size: 32px;
  font-weight: 500;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Part1Text2Mobile = styled.div`
  display: none;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  width: 300px;
  @media (max-width: 430px) {
    display: block;
  }
`;
export const Part1Text2 = styled.div`
  display: block;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  width: 330px;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const Part2Text1 = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  display: flex;
  flex-direction: row;
`;
export const Part2Text2 = styled.a`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  border: none;
  background-color: #ffffff;
  color: #55749f;
`;
